import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function useOnLeavePage(callback: VoidFunction) {
  const router = useRouter();

  useEffect(() => {
    const handleLeave = (path: string, _opt: { shallow?: boolean }) => {
      // We leave the page if the new pathname is different. Otherwise, we just refreshed the same page, and we may not want to call the callback function.
      path = trimQueryPart(path);
      const asPath = trimQueryPart(router.asPath);

      if (path !== asPath) {
        callback?.();
      }
    };

    router.events.on('routeChangeStart', handleLeave);
    return () => {
      router.events.off('routeChangeStart', handleLeave);
    };
  }, [callback, router]);
}

function trimQueryPart(path: string) {
  const i = path.indexOf('?');
  return i === -1 ? path : path.slice(0, path.indexOf('?'));
}
